<template>
  <div class="app-container">
    <div class="top_btns clearfix">
      <div class="left_box">
        <search @success="getList()">
          <el-form style="margin:11px 0px 0px -26px;height:270px;width:430px" class="styleForm">
            <el-form-item label="辅助类别 ：" :label-width="formLabelWidth"> 
              <fzhsSubjectList v-model:fzhsId="listQuery.fzhsId" @initSuccess="getList"></fzhsSubjectList>
            </el-form-item>
            <el-form-item label="选择期间 ：" :label-width="formLabelWidth">
              <qzf-period v-model:period="listQuery.period"></qzf-period>
            </el-form-item>
            <el-form-item label="核算名称 ：" :label-width="formLabelWidth"> 
              <el-input size="mini" v-model="listQuery.name" style="width:60%"></el-input>
            </el-form-item>
            <el-form-item label-width="42px" style="height:10px"> 
              <el-checkbox v-model="listQuery.not0" label="余额为0不显示"></el-checkbox>
            </el-form-item>
            <el-form-item label-width="42px" style="height:10px"> 
              <el-checkbox v-model="wbstatus" label="显示数量金额"></el-checkbox>
            </el-form-item>
            <el-form-item label-width="42px" style="height:10px">
              <el-checkbox v-model="yearAmount" label="隐藏本年累计发生额"></el-checkbox>
            </el-form-item>
          </el-form>
        </search>
      </div>
    </div>

    <el-table show-summary :summary-method="getSummaries" :height="contentStyleObj" size="mini" :data="showList" border fit highlight-current-row style="width: 100%;" v-loading="loading">
        <el-table-column label="核算编码" width="160" align="center">
          <template #default="scope">
            <span class="bianma">{{scope.row.code}}</span>
          </template>
        </el-table-column>

        <el-table-column label="核算名称" min-width="240" align="center">
          <template #default="scope">
            <span class="name_css">{{scope.row.name}}</span>
          </template>
        </el-table-column>

        <el-table-column label="期初余额" align="center">
          <el-table-column  align="center" prop="periodBeginIn" label="借方" width="120">
            <template #default="scope">
              <!-- <span>{{scope.row.periodBeginIn}}</span> -->
              <span>{{scope.row.periodBeginIn}}</span>
            </template>
          </el-table-column>
          <el-table-column  align="center" prop="periodBeginOut" label="贷方" width="120">
            <template #default="scope">
              <!-- <span>{{scope.row.periodBeginOut}}</span> -->
              <span>{{scope.row.periodBeginOut}}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="wbstatus" align="center" prop="beginCount" label="数量" width="120">
            <template #default="scope">
              <!-- <span>{{scope.row.periodBeginOut}}</span> -->
              <span>{{scope.row.beginCount}}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="本期发生额" align="center">
          <el-table-column align="center" prop="periodInt" label="借方" width="120">
            <template #default="scope">
              <!-- <span>{{scope.row.periodInt}}</span> -->
              <span>{{scope.row.periodInt}}</span>
            </template>
          </el-table-column>  
          <el-table-column align="center" prop="periodOut" label="贷方" width="120">
            <template #default="scope">
              <!-- <span>{{scope.row.periodOut}}</span> -->
              <span>{{scope.row.periodOut}}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="wbstatus" align="center" prop="inCount" label="数量借" width="120">
            <template #default="scope">
              <!-- <span>{{scope.row.periodBeginOut}}</span> -->
              <span>{{scope.row.inCount}}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="wbstatus" align="center" prop="outCount" label="数量贷" width="120">
            <template #default="scope">
              <!-- <span>{{scope.row.periodBeginOut}}</span> -->
              <span>{{scope.row.outCount}}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="本年累计发生额" align="center" v-if="yearAmount == false">
          <el-table-column align="center" prop="yearInt" label="借方" width="120">
            <template #default="scope">
              <!-- <span>{{scope.row.yearInt}}</span> -->
              <span>{{scope.row.yearInt}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="yearOut" label="贷方" width="120">
            <template #default="scope">
              <!-- <span>{{scope.row.yearOut}}</span> -->
              <span>{{scope.row.yearOut}}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="期末余额" align="center">
          <el-table-column align="center" prop="periodEndIn" label="借方" width="120">
            <template #default="scope">
              <span>{{scope.row.periodEndIn}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="periodEndOut" label="贷方" width="120">
            <template #default="scope">
              <span>{{scope.row.periodEndOut}}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="wbstatus" align="center" prop="endCount" label="数量" width="120">
            <template #default="scope">
              <span>{{scope.row.periodBeginOut}}</span>
            </template>
          </el-table-column>
        </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { fzhsBalanceList  } from "@/api/subject"
import fzhsSubjectList from "./fzhsSubjectList.vue"
export default {
  name:'fzhsSubjectBalance',
  components :{ fzhsSubjectList },
  data() {
    return {
      showList:[],
      formLabelWidth: '120px',
      listQuery: {
        comId: this.$store.getters['user/comInfo'].comId*1,
        period: this.$store.getters['user/comInfo'].period,
        fzhsId: 0,
        not0: false,
        name: '',
        level: 1,
      },
      yearAmount:false,
      wbstatus:false,
      loading:false
    }
  },
  created() {
    this.contentStyleObj=this.$getHeight(200)
  },
  methods:{
    getList(){
      this.loading = true
      fzhsBalanceList(this.listQuery).then(res=>{
        this.loading = false
        this.showList = res.data.data.list
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.top_btns {
  .left_box{
    float: left;
    width: 70%;
    margin-bottom: 10px;
  }
  .right_box {
    float: right;
    width: 30%;
    text-align: right;
  }
}
.styleForm{
  .el-select{
    margin: 0px;
  }
}
</style>